<div class="loader-container">
  <div class="loader">
    <mat-spinner></mat-spinner>
  </div>
</div>
